import React from "react";
import { Typography } from "@mui/material";

export default function NoTicketDetail(): JSX.Element {
    return (
        <>
            <Typography fontSize={"xx-large"} color={"red"}>
                No Ticket Selected
            </Typography>
        </>
    );
}
